import React from 'react';

const LazyComponent = React.lazy(() =>
    import(
        /* webpackChunkName: "SbSharedNullSearchRelatedItemsFollow" */ './SbSharedNullSearchRelatedItemsFollow'
    )
);

export const SbSharedNullSearchRelatedItemsFollowLazy = props => (
    <React.Suspense fallback="">
        <LazyComponent {...props} />
    </React.Suspense>
);
